import { useState } from "react";
import {
  Box,
  Typography,
  Grid,
  Stack,
  Divider,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { darkColors } from "../../theme/colors";
import { assetIcons } from "../../constants/assets";
import { fontSizes } from "../../theme/font-sizes";
import AccountSidebar from "./account-sidebar";
import { StyledTypography } from "./account";
import DashedButton from "../utils/dashed-button";
import englishTranslations from "../../i18n/translations/en";
import { useNavigate } from "react-router-dom";
import routes from "../../constants/routes";
import InlineSvg from "../utils/inline-svg";
import { useUser } from "../../context/user-context";
// Custom styled components

export default function BillingComponent() {
  const navigate = useNavigate();
  const theme = useTheme();
  const { user } = useUser();

  const isMediumScreen = useMediaQuery(theme.breakpoints.down("lg"));

  const navigateToSettings = () => {
    navigate(routes.settings);
  };
  return (
    <Box sx={{ display: "flex", bgcolor: "#171717", height: "100vh" }}>
      {/* Sidebar */}
      {!isMediumScreen && <AccountSidebar />}

      {/* Main content */}
      <Box
        // component="main"
        display={"flex-col"}
        sx={{
          //   flexGrow: 1,
          p: isMediumScreen ? 4 : 10,
          width: "100%",
          overflowY: "auto",
          "&::-webkit-scrollbar": {
            display: "none", // Hide scrollbar in WebKit browsers (Chrome, Safari)
          },
          pt: isMediumScreen ? 5 : 8,
          mb: 7,
          bgcolor: "#121212",
          color: "#fff",
        }}
      >
        {/* <Container maxWidth=""> */}
        <Box
          onClick={navigateToSettings}
          display={"flex"}
          sx={{ cursor: "pointer" }}
          alignItems="center"
        >
          {isMediumScreen && (
            <InlineSvg
              sx={{
                cursor: "pointer",
                display: "inline-block",
                width: 20,
                mr: 3,
                pb: 4,
              }}
              url={assetIcons.leftArrow}
            />
          )}
          <Typography
            fontFamily={"MontserratBold"}
            component="span"
            fontSize={
              isMediumScreen ? fontSizes.heading2 : fontSizes.superHeading5
            }
            textAlign={"left"}
            sx={{ mb: isMediumScreen ? 4 : 6 }}
            // onClick={(e) => e.stopPropagation()}
          >
            Billing
          </Typography>{" "}
        </Box>

        <Grid container spacing={6}>
          {/* Profile Picture Section */}
          <Grid item xs={12}>
            <Stack
              direction={isMediumScreen ? "column" : "row"}
              spacing={isMediumScreen ? 2 : "10%"}
              justifyContent={isMediumScreen ? "space-between" : "start"}
              alignItems="start"
            >
              <Stack>
                <Typography
                  fontFamily={"MontserratBold"}
                  fontSize={fontSizes.heading3}
                  textAlign={"left"}
                  sx={{ width: isMediumScreen ? "100%" : 180 }}
                >
                  Payment Method
                </Typography>
              </Stack>

              <Stack justifyContent={"left"} width={"100%"}>
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: user?.wallet ? "center" : "center",
                    gap: 2,
                    border: `1px solid ${darkColors.borderGray}`,
                    p: 2,
                    borderRadius: "12px",
                    width: isMediumScreen ? "90%" : "385px",
                  }}
                >
                  <Typography
                    sx={{
                      color: "white",
                      fontSize: fontSizes.heading3,
                      fontWeight: 700,
                    }}
                  >
                    {user?.wallet ? "Wallet Ending " : ""}
                    {user.wallet?.address
                      ? user.wallet.address.slice(-4)
                      : "No Wallet Connected Yet"}
                  </Typography>
                </Box>
                {/* <Stack mt={4}>
                  <DashedButton
                    text={englishTranslations.wallet.add_wallet}
                    width={isMediumScreen ? "100%" : "420px"}
                    borderRadius={12}
                    fontsize={fontSizes.heading3}
                  />{" "}
                </Stack> */}
              </Stack>
            </Stack>
          </Grid>
        </Grid>

        {!isMediumScreen && (
          <Box
            mt={6}
            sx={{
              maxWidth: isMediumScreen ? "100%" : "calc(14% + 550px)",
            }}
          >
            <Divider
              sx={{
                background: darkColors.gray,
                width: "100%",
              }}
            />
          </Box>
        )}

        {/* </Container> */}
      </Box>
    </Box>
  );
}
